import React from 'react'
import { Switch, Route } from 'react-router-dom'
import Navigation from '../components/Navigation'
import PatientsList from '../Patients/containers/PatientsList'
import PatientView from '../Patients/containers/PatientView'
import EditPatientGoals from '../Goal/containers/EditPatientGoals'
import AddPatientChannel from '../Patients/containers/AddPatientChannel'
import { connect } from 'react-redux'
import { getAccessToken } from '@medeo/user'
import jwt from 'jsonwebtoken'

const MainView = ({ role }) => [
  <Navigation key="navigation" />,
  <Switch key="main">
    <Route path="/goals/edit/:patientId" component={EditPatientGoals} />
    {role === 'practitioner' ? (
      <Route path="/patients/add" component={AddPatientChannel} />
    ) : null}
    <Route path="/patients/:patientId" component={PatientView} />
    <Route exact path="/patients" component={PatientsList} />
  </Switch>
]
const mapStateToProps = state => {
  const accessToken = getAccessToken(state)
  const { allowedApplications } = jwt.decode(accessToken)
  const role = allowedApplications.find(
    application => application.name === 'tls-site'
  ).role
  return { role }
}
export default connect(mapStateToProps)(MainView)



// WEBPACK FOOTER //
// ./src/containers/MainView.js